import { Controller } from "@hotwired/stimulus"

// Orchestrated page-load reveal (CLAUDE_DESIGN §6.2): the Ghaf wordmark draws
// itself in brass on first paint — one quiet moment. The hero line rise is
// handled by the reveal controller. Reduced-motion → instantly present; runs
// once per session so in-session Turbo navigations don't re-draw it.
export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    try { if (sessionStorage.getItem("gh-intro")) return } catch (e) {}

    const paths = this.element.querySelectorAll("path")
    paths.forEach((p, i) => {
      const len = p.getTotalLength()
      p.style.strokeDasharray = len
      p.style.strokeDashoffset = len
      p.getBoundingClientRect() // force reflow so the transition takes
      p.style.transition = `stroke-dashoffset var(--t-slow) var(--ease) ${i * 55}ms`
      requestAnimationFrame(() => { p.style.strokeDashoffset = "0" })
    })

    try { sessionStorage.setItem("gh-intro", "1") } catch (e) {}
  }
}
